// @ts-nocheck
// The inspector: one sentence per thing the agent does, plus what is still
// missing before publish. Flow chart lives here as a secondary action.
import { useState } from 'react';
import { CheckCircle2, ChevronDown, CircleDashed } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

export default function AgentSummary({ lines, missing, children, className }) {
  const [open, setOpen] = useState(true);
  return (
    <aside
      aria-label="Agent summary"
      className={cn(
        'space-y-4 overflow-y-auto rounded-2xl border border-border p-4',
        'bg-card/80 supports-[backdrop-filter]:bg-card/55 supports-[backdrop-filter]:backdrop-blur-xl',
        className,
      )}
    >
      {/* flow chart and jump first, summary below and collapsible */}
      {children}

      <div className="space-y-4">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          className="flex w-full items-center justify-between gap-2 text-left"
        >
          <span>
            <span className="block text-sm font-semibold text-foreground">Agent summary</span>
            <span className="mt-0.5 block text-xs text-muted-foreground">What this agent will do on a call.</span>
          </span>
          <ChevronDown className={cn('h-4 w-4 shrink-0 text-muted-foreground transition-transform', open && 'rotate-180')} />
        </button>
        {open && (
          <>
          <ul className="space-y-2">
            {lines.map((line) => (
              <li key={line} className="flex gap-2 text-sm leading-relaxed text-muted-foreground">
                <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[hsl(var(--success))]" />
                <span>{line}</span>
              </li>
            ))}
          </ul>

          <div className="rounded-xl border border-border bg-muted/40 p-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              {missing.length ? `Before publish — ${missing.length} left` : 'Ready to publish'}
            </p>
            {missing.length ? (
              <ul className="mt-2 space-y-1.5">
                {missing.map((m) => (
                  <li key={m.id} className="flex gap-2 text-xs text-muted-foreground">
                    <CircleDashed className="mt-0.5 h-3 w-3 shrink-0" />
                    <span>{m.label}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="mt-1.5 text-xs text-muted-foreground">Everything required is filled in.</p>
            )}
          </div>
          </>
        )}
      </div>
    </aside>
  );
}
